import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { Pencil, X, LockSimple } from '@phosphor-icons/react';

export const ProfileHeader = ({ user, rank, isOwnProfile, isEditing, onEdit, onClose }) => {
  return (
    <div className="bg-[#0047FF] p-6 relative">
      <Button
        variant="ghost"
        size="icon"
        onClick={onClose}
        className="absolute top-4 right-4 text-white hover:bg-white/20"
        data-testid="close-profile-button"
      >
        <X size={20} weight="bold" />
      </Button>
      
      <div className="flex items-start gap-4 pr-10">
        <Avatar className="h-20 w-20 border-2 border-white">
          <AvatarImage src={user.avatar} alt={user.username} />
          <AvatarFallback className="text-2xl">{user.username[0]}</AvatarFallback>
        </Avatar>
        <div className="flex-1">
          <h2 className="font-heading text-2xl font-bold text-white mb-1">{user.username}</h2>
          {user.email && <p className="text-white/80 text-sm mb-2">{user.email}</p>}
          <div className="flex items-center gap-4 text-white/90 text-sm">
            <span className="font-mono">Rank #{rank}</span>
            <span className="font-mono">{user.score.toLocaleString()} pts</span>
            {user.profile_visibility === 'private' && (
              <span className="inline-flex items-center gap-1 text-xs bg-white/15 px-2 py-0.5" data-testid="profile-private-badge">
                <LockSimple size={12} weight="fill" /> Private
              </span>
            )}
          </div>
        </div>
        {isOwnProfile && !isEditing && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onEdit}
            className="text-white hover:bg-white/20"
            data-testid="edit-profile-button"
          >
            <Pencil size={16} weight="regular" className="mr-2" />
            Edit Profile
          </Button>
        )}
      </div>
    </div>
  );
};
